import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {InsolesModelSummaryModel} from "./insolesModelSummary.model";
import {PermissionsConverter} from "../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesModelSummaryConverter extends HttpModelConverter<InsolesModelSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): InsolesModelSummaryModel {
        return new InsolesModelSummaryModel();
    }

    protected enrichObject(result: InsolesModelSummaryModel, src: InsolesModelSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}
